import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-edit-truck-category",
  templateUrl: "./admin-edit-truck-category.component.html",
  styleUrls: ["./admin-edit-truck-category.component.css"],
})
export class AdminEditTruckCategoryComponent implements OnInit {
  truckCategory: any;
  token: any;
  editTruckCategory: boolean = false;
  editButton: boolean = true;
  saveButton: boolean = false;
  editTruckForm!: FormGroup;
  file: any = "";
  profileImage: any;
  loading: boolean = false;

  constructor(
    private services: AdminService,
    private formBuilder: FormBuilder,
    private matdialogref: MatDialogRef<AdminEditTruckCategoryComponent>,
    private snackBar: MatSnackBar,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.editTruckForm = this.formBuilder.group({
      truck_category_name: [
        "",
        [Validators.required, Validators.pattern("^[a-zA-Z][a-zA-Z\\s]+$")],
      ],
      category_description: [
        "",
        [Validators.required, Validators.pattern("^[a-zA-Z][a-zA-Z\\s]+$")],
      ],
      category_image: [""],
    });
  }
  truckCategoryGet() {
    this.services.getTrucksCatg(this.token).subscribe((response: any) => {
      this.truckCategory = response.body.data;
    });
  }
  public get truckCategoryFormControl() {
    return this.editTruckForm.controls;
  }

  editDriver() {
    this.editTruckCategory = true;
    this.editButton = false;
    this.truckCategoryFormControl["truck_category_name"].setValue(
      this.data.truck_category_name
    );
    this.truckCategoryFormControl["category_description"].setValue(
      this.data.category_description
    );
    this.profileImage = this.data.category_image;
  }

  updateTruckCatg(event: any) {
    if (!this.editTruckForm.valid || this.loading) {
      return; // Prevent clicks if already loading
    }
    this.loading = true; // Disable button immediately
    (event.target as HTMLButtonElement).disabled = true; // Disable button instantly
    const updateTruckObj = {
      truck_category_name: this.editTruckForm.value.truck_category_name,
      category_description: this.editTruckForm.value.category_description,
      category_image: this.profileImage,
    };
    this.services.truckCatgUpdate(updateTruckObj, this.token, this.data._id).subscribe(
      (response: any) => {
        if (response.status == "201") {
          this.snackBar.open(
            "Truck category updated successfully",
            "Success",
            {
              duration: 5000,
            }
          );
          this.loading = false;
          this.truckCategoryGet();
          this.matdialogref.close();
        }
        setTimeout(() => {
          this.loading = false; // Enable button after response
          (event.target as HTMLButtonElement).disabled = false; // Re-enable button
        }, 500);
      },
      (error) => {
        this.loading = false;
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  public onChange(event: any): void {
    this.loading = true;
    this.file = event.target.files[0];
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (this.file && !allowedTypes.includes(this.file.type)) {
      this.loading = false;
      this.snackBar.open("Unsupported file format. Upload JPG, JPEG, or PNG image.", "Close", {
        duration: 4000,
      });
      return;
    }
    this.services.uploadImage(this.file).subscribe(
      (response: any) => {
        if (response.status === 201) {
          this.profileImage = response.body.image_link;
          this.loading = false;
          this.snackBar.open("Image uploaded successfully!", "OK", {
            duration: 4000,
          });
        }
      },
      (error) => {
        this.loading = false;
        // JWT-related errors → redirect
        if (["jwt malformed", "jwt expired", "invalid signature"].includes(error.error.message)) {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message || "Image upload failed.", "Fail", {
          duration: 5000,
        });
      }
    );
  }
  close() {
    this.matdialogref.close();
  }
}
